import { CLEAR } from "../types"

export const clear = () => {
  return { type: CLEAR }
}
